<template>
    <b-modal
        :visible="deprecationModalVisible"
        :title="$t('Update Available')"
        :no-close-on-backdrop="!allowContinue"
        :no-close-on-esc="!allowContinue"
        :hide-header-close="!allowContinue"
        hide-footer
        centered
        @hidden="dismissed = true"
    >
        <div>
            {{
                $t(
                    "This version of the app is being retired. Install the new app to continue."
                )
            }}
        </div>
        <b-btn
            @click="openDeprecationUrl"
            variant="primary"
            pill
            block
            size="lg"
            class="mt-3"
        >
            {{ $t("Get the New App") }}
        </b-btn>
        <b-btn
            v-if="allowContinue"
            @click="dismissed = true"
            variant="link"
            block
            size="sm"
            class="mt-2 text-secondary"
        >
            {{ $t("Continue for now") }}
        </b-btn>
    </b-modal>
</template>

<script>
import { mapState } from "vuex";

// Pure backend determiner (options.deprecation): a url means show the dialog,
// allowContinue false removes every way out — the forced-upgrade phase.
export default {
    data() {
        return {
            dismissed: false,
        };
    },
    computed: {
        deprecationModalVisible() {
            return this.deprecation && this.deprecation.url && !this.dismissed
                ? true
                : false;
        },
        allowContinue() {
            return this.deprecation && this.deprecation.allowContinue
                ? true
                : false;
        },
        ...mapState("options", ["deprecation"]),
    },
    methods: {
        openDeprecationUrl() {
            this.$store.dispatch("system/openBrowser", this.deprecation.url);
        },
    },
};
</script>
